const firmasmodulo = {
    BuscarProcesados: 'SIVAC/Firmas/BuscarProcesados',
    BuscarProcesadosParaFirmar: 'SIVAC/Firmas/BuscarProcesadosParaFirmar',
    GenerarNuevaFirma: 'SIVAC/Firmas/GenerarNuevaFirma',
    GenerarNuevaFirmaManual: 'SIVAC/Firmas/GenerarNuevaFirmaManual',
    VerificarRegistroDispositivo: 'SIVAC/Firmas/VerificarRegistrodelDispositivo'

      

}

const firmas = {
    firmasmodulo: firmasmodulo
}

export default firmas;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIVAC/Sistema/Firmas/firmas.js
// module id = null
// module chunks = 